import axios from 'axios';

export default {
  data() {
    return {
      passwordRules: [
        {
          message: 'Must have at least 1 number',
          regex: /[0-9]+/,
          property: 'PW_NUMBER_REQD',
          active: false,
        },
        {
          message: 'Must have at least 1 upper case letter',
          regex: /[A-Z]+/,
          property: 'PW_UPPER_CASE_REQD',
          active: false,
        },
        {
          message: 'Must have at least 1 lower case letter.',
          regex: /[a-z]+/,
          property: 'PW_LOWER_CASE_REQD',
          active: false,
        },
        {
          message: 'Must have at least 1 special character',
          regex: /[@#$%!&*?]+/,
          property: 'PW_SPECIAL_CHAR_REQD',
          active: false,
        },
        {
          message: 'Must be 8 to 20 characters long',
          regex: /.{8,20}/,
          property: 'PW_LENGTH',
          active: false,
        },
        {
          message: 'Must not contain your user name (email address)',
          regex: '',
          active: false,
          property: 'PW_EXCL_USERNAME',
        },
        {
          message: 'Must be different from your previous password',
          regex: '',
          property: 'PW_MUST_BE_UNIQUE',
          active: false,
          ignoreForSignup: true,
        },

      ],
      initialized: false,
    };
  },
  async mounted() {
    this.getPasswordRules();
  },
  computed: {
    activeRules() {
      return this.passwordRules.filter(r => r.active === true);
    },
    signUpRules() {
      return this.activeRules.filter((r) => {
        const hasProperty = Object.prototype.hasOwnProperty.call(r, 'ignoreForSignup');
        if (!hasProperty || r.ignoreForSignup !== true) return r;
      });
    },
  },
  methods: {
    async getPasswordRules() {
      try {
        let min = 1;
        let max = 60;
        const res = await axios.get('login/rules');
        Object.entries(res.data).forEach(([key, value]) => {
          this.passwordRules.forEach((rule, index) => {
            if (rule.property === key) {
              this.passwordRules[index].active = (value === 'true');
            } else if (rule.property === 'PW_LENGTH') {
              if (key === 'PW_MIN_LENGTH') {
                min = value;
                this.passwordRules[index].active = true;
              } else if (key === 'PW_MAX_LENGTH') {
                max = value;
                this.passwordRules[index].active = true;
              }
            }
          });
        });
        this.passwordRules.forEach((rule, index) => {
          if (rule.property === 'PW_LENGTH' && rule.active === true) {
            const r = new RegExp(`.{${min},${max}}`);
            this.passwordRules[index].regex = r;
            this.passwordRules[index].message = `Must be ${min} to ${max} characters long`;
          }
        });
      } catch (error) {
        // handle error
      }
    },
    rulesFailed(email, password) {
      const failed = [];
      this.passwordRules.forEach((r) => {
        if (r.active) {
          if (r.regex) {
            const regex = new RegExp(r.regex);
            if (!regex.test(password)) {
              failed.push(r.message);
            }
          } else if (r.property === 'PW_EXCL_USERNAME') {
            if (password.toLowerCase().indexOf(email.replace(/@[^@]+$/, '').toLowerCase()) > -1) {
              failed.push(r.message);
            }
          }
        }
      });
      return failed;
    },
  },
};
